export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./speakLoading.vue?vue&type=template&id=ca08a1a8&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/speakLoading.vue?vue&type=template&id=ca08a1a8&scoped=true&
// module id = null
// module chunks = 